import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';
import {GLOBAL_RESET} from 'shared/constants/ActionTypes';
import CommonReducer from './CommonReducer';
import MemberReducer from './MemberReducer';
import Settings from './Setting';
import WidgetReducer from './WidgetReducer';

const appReducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    commonReducer: CommonReducer,
    widgetReducer: WidgetReducer,
    memberReducer: MemberReducer,
  });

export const rootReducer = (history) => (state, action) => {
  if (action.type === GLOBAL_RESET) {
    // We preserve the 'router' state if you don't want the URL to reset,
    // but usually for a user switch, a full wipe is safer.
    // Passing undefined here is the Redux "magic" that triggers initialStates.
    state = undefined;
  }
  return appReducers(history)(state, action);
};

export default rootReducer;
